import { SHOW_EVH_INFOWINDOW,  HIDE_EVH_INFOWINDOW} from "./evhInfoWindowReducer"

export const showEvhInfoWindow = (obj) => ({
    type: SHOW_EVH_INFOWINDOW,
    payload: obj
})

export const hideEvhInfoWindow = () => ({
    type: HIDE_EVH_INFOWINDOW,
})